import { Box, Button, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDataCall } from "./dataCall";
import { useState } from "react";
import {
  ConditionalRenderer,
  LatestReport,
  Header,
  Filters,
  useLanguageTranslator,
} from "../../components";

function AllReports() {
  const [filters, setFilters] = useState({
    country: "",
    startYear: "",
    endYear: "",
    theme: "",
  });
  const [pageNumber, setPageNumber] = useState(1);

  const { module } = useParams();
  const { translator } = useLanguageTranslator();
  const documentsData = useDataCall({
    module: module,
    variables: {
      limit: 8,
      page: pageNumber,
      ...(filters?.country && filters?.country !== "0"
        ? { countryId: Number(filters?.country) }
        : {}),
      ...(filters?.theme && filters?.theme !== "0"
        ? { themeId: Number(filters?.theme) }
        : {}),
      ...(filters?.startYear ? { startYear: Number(filters?.startYear) } : {}),
      ...(filters?.endYear ? { endYear: Number(filters?.endYear) } : {}),
    },
  }) as any;

  const { data, loading } = documentsData || {};

  function onClickHandler() {
    if (
      module === "policies"
        ? pageNumber === data?.policyDocuments?.metadata?.totalPages
        : pageNumber === data?.practiceDocuments?.metadata?.totalPages
    )
      return;
    setPageNumber(pageNumber + 1);
  }

  const hasMore =
    module === "policies"
      ? pageNumber === data?.policyDocuments?.metadata?.totalPages ||
        !data?.policyDocuments?.metadata?.totalPages
      : pageNumber === data?.practiceDocuments?.metadata?.totalPages ||
        !data?.practiceDocuments?.metadata?.totalPages;

  return (
    <Box pb={3}>
      <Header
        title="Reports"
        subtitle=""
      />
      <Filters setFilters={setFilters} filters={filters} />
      <LatestReport
        isAllShow={false}
        items={
          data?.policyDocuments?.collection ||
          data?.practiceDocuments?.collection ||
          []
        }
        path={`${
          data?.policyDocuments?.collection
            ? "/policies/view-all-Reports"
            : "/practices/view-all-Reports"
        }`}
        loading={loading}
      />
      <ConditionalRenderer condition={!hasMore}>
        <Paper sx={{ py: 2, display: "flex", justifyContent: "center" }}>
          <Button onClick={onClickHandler}>{translator("Show more")}</Button>
        </Paper>
      </ConditionalRenderer>
    </Box>
  );
}

export { AllReports };
